import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { DeleteCostCenterAssignmentModal } from '../../DeleteModal'

interface Props {
  ids: number[]
  onDelete?: () => void
}

export const DeleteButton = ({ ids, onDelete }: Props) => {
  const [confirmModal, setConfirmModal] = useState(false)

  const handleOnDelete = () => {
    onDelete?.()

    closeConfirmModal()
  }

  const openConfirmModal = () => {
    setConfirmModal(true)
  }

  const closeConfirmModal = () => {
    setConfirmModal(false)
  }

  return (
    <>
      <Button type="negative" onClick={openConfirmModal} iconName="delete">
        {i18n.t('common.delete')}
      </Button>

      {confirmModal && (
        <DeleteCostCenterAssignmentModal
          ids={ids}
          onClose={closeConfirmModal}
          onSubmit={handleOnDelete}
        />
      )}
    </>
  )
}
